(() => {
  if (window.nhCartFooter) return;
  let config;
  try { config = JSON.parse(document.getElementById('nh-cart-config')?.textContent || '{}'); } catch { return; }
  if (typeof config.labels?.discount !== 'string' || !config.labels.discount) return;
  window.nhCartFooter = true;
  let expanded = false;
  let root = null;
  let form = null;
  let button = null;
  let observer = null;
  let discovery = null;
  let scheduled = false;
  let lastError = '';

  const synchronize = () => {
    scheduled = false;
    const nextForm = root?.querySelector('.discount-box-form');
    if (!nextForm) {
      button?.remove();
      button = null;
      form = null;
      return;
    }
    form = nextForm;
    const errorText = form.closest('.discount-box')?.querySelector('[role="alert"]')?.textContent.trim() || '';
    if (errorText && errorText !== lastError) expanded = true;
    lastError = errorText;
    if (!form.id) form.id = 'nh-cart-discount-form';
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'nh-cart-discount-toggle';
      button.dataset.nhDiscountToggle = '';
      const label = document.createElement('span');
      label.textContent = config.labels.discount;
      const icon = document.createElement('span');
      icon.className = 'nh-cart-discount-toggle__icon';
      icon.setAttribute('aria-hidden', 'true');
      button.append(label, icon);
      button.addEventListener('click', () => {
        expanded = !expanded;
        synchronize();
        if (expanded) form?.querySelector('input:not([type="hidden"])')?.focus({ preventScroll: true });
      });
    }
    if (button.nextElementSibling !== form) form.before(button);
    button.setAttribute('aria-controls', form.id);
    button.setAttribute('aria-expanded', String(expanded));
    const icon = button.querySelector('.nh-cart-discount-toggle__icon');
    const symbol = expanded ? '−' : '+';
    if (icon.textContent !== symbol) icon.textContent = symbol;
    if (expanded) form.removeAttribute('data-nh-discount-collapsed');
    else form.setAttribute('data-nh-discount-collapsed', 'true');
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(synchronize);
  };

  const attach = () => {
    const nextRoot = document.getElementById('slidecarthq');
    if (!nextRoot) return false;
    if (nextRoot !== root) {
      observer?.disconnect();
      root = nextRoot;
      observer = new MutationObserver((records) => {
        if (records.some((record) => !button?.contains(record.target))) schedule();
      });
      observer.observe(root, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['class', 'hidden', 'aria-invalid']
      });
    }
    discovery?.disconnect();
    discovery = null;
    synchronize();
    return true;
  };

  const start = () => {
    if (attach()) return;
    discovery = new MutationObserver(attach);
    discovery.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
